import React, { useState } from 'react';
import './Popup.scss';
import PopupComponent from './PopupComponent';

const Popup = ({ onClose }) => {
  const [showPopup, setShowPopup] = useState(true);
  const [showProgress, setShowProgress] = useState(false);

  // Handler to manage the transition from the initial popup to PopupComponent
  const handleConfirm = () => {
    console.log('Transitioning to PopupComponent');
    setShowPopup(false); // Hide initial popup
    setShowProgress(true); // Show PopupComponent
  };

  // Handler to close PopupComponent and perform final cleanup
  const handleClosePopupComponent = () => {
    console.log('Closing PopupComponent');
    setShowProgress(false);  // Ensure no popup is visible
    onClose(); // Close everything and perform any additional cleanup
  };

  return (
    <>
      {showPopup && (
        <div className="popup-overlay">
          <div className="popup">
            <div className="popup-content">
              <p>Do you want to confirm the operation?</p>
              <div className="popup-actions">
                <button onClick={onClose} className="close-button">Cancel</button>
                <button onClick={handleConfirm} className="confirm-button">confirm</button>
              </div>
            </div>
          </div>
        </div>
      )}
      {showProgress && <PopupComponent onClose={handleClosePopupComponent} />}
    </>
  );
};

export default Popup;
